<template>
    <div
        class="submenu-list brands-submenu-list"
        :class="{ 'is-mobile': mobile }"
    >
        <button type="button" class="back-button" @click="$emit('close')">
            <ChevronLeft :size="mobile ? 27 : 24" :stroke-width="1.5" />
            {{ menuItem.label }}
        </button>

        <ul class="brands-grid">
            <li v-for="child in visibleChildren" :key="child.label">
                <router-link
                    :to="child.href"
                    class="brand-link"
                    :aria-label="child.label"
                    :title="child.label"
                    @click.native="$emit('select')"
                >
                    <span
                        class="brand-logo"
                        :style="{ '--brand-logo': `url('${child.logo}')` }"
                        aria-hidden="true"
                    ></span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { ChevronLeft } from "lucide-vue";
import { visibleMenuItems } from "./menuLinks";

const props = defineProps({
    menuItem: {
        type: Object,
        required: true,
    },
    mobile: {
        type: Boolean,
        default: false,
    },
});

const visibleChildren = computed(() =>
    visibleMenuItems(props.menuItem.children)
);
</script>

<style lang="scss" scoped>
.brands-submenu-list {
    overflow-y: auto;

    .back-button {
        align-items: center;
        background: none;
        border: none;
        color: var(--color-dark-grey) !important;
        cursor: pointer;
        display: flex;
        font-size: var(--font-size-lg) !important;
        font-weight: bold;
        gap: 0.25rem;
        margin: 1rem 0;
        padding: 0;
        text-align: left;
        text-transform: uppercase;
        width: 100%;
    }

    .brands-grid {
        display: grid;
        gap: 1.75rem 1.25rem;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .brand-link {
        align-items: center;
        display: flex;
        height: 4.25rem;
        justify-content: center;
        padding: 0.35rem;
        width: 100%;
        max-width: 90px;
        margin: 0 auto;
        opacity: 0.95;

        &:focus-visible {
            outline: 2px solid #cd1b00;
            outline-offset: 4px;
        }

        &:hover,
        &:focus-visible {
            .brand-logo {
                background-color: #cd1b00;
                transform: scale(1.04);
            }
        }
    }

    .brand-logo {
        -webkit-mask-image: var(--brand-logo);
        -webkit-mask-position: center;
        -webkit-mask-repeat: no-repeat;
        -webkit-mask-size: contain;
        background-color: #333;
        display: block;
        height: 3.25rem;
        mask-image: var(--brand-logo);
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: contain;
        max-width: 7.25rem;
        transition: background-color 180ms ease, transform 180ms ease;
        width: 100%;
    }

    &.is-mobile {
        .back-button {
            font-family: "acumin-pro-condensed", Helvetica, Arial, sans-serif;
            font-size: 25px !important;
            gap: 10px;
            line-height: 1.1;
            margin: 0 0 8px;
            min-height: 56px;
            padding: 4px 0 12px;
        }
    }
}
</style>
